export enum EnvelopeMode {
  Adaptative = 0,
  FlatAbsolute = 1,
  FlatRelative = 2,
}
